import {useState} from "react";
import {Button} from "@/primitives/Button";
import {FA6Icon} from "@/primitives/FA6Icon";
import {Modal} from "@/primitives/Modal";
import {AbsenceCalendarLinks, type AbsenceCalendarLinksProps} from "@/features/absence/absenceCalendarLinks";

export type AbsenceCalendarLinksModalProps = Omit<AbsenceCalendarLinksProps, "onBusyChange">;

/**
 * The absence calendar subscription links as a dialog, for pages that show them on demand
 * instead of in a panel. Meant to be driven by a `ModalIsland` from a legacy page class.
 */
export function AbsenceCalendarLinksModal(props: AbsenceCalendarLinksModalProps) {
	/*
	 * A `ModalIsland` remounts the content on every open, so closing mid-request would drop the
	 * pending response and reopen with the token the server is just rotating away. Dismissing is
	 * therefore blocked while a token request runs.
	 */
	const [busy, setBusy] = useState(false);

	return (
		<Modal.Content size="lg" showCloseIcon={!busy}>
			<Modal.Header>
				<Modal.Title>{messages["admin.clientSettings.absenceCalendar"]}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<AbsenceCalendarLinks {...props} onBusyChange={setBusy}/>
			</Modal.Body>
			<Modal.Footer>
				{/* the footer is a flex row ending right, so `mr-auto` pushes this one to the left
				    edge — the legacy dialog used Bootstrap's `pull-left`, which a flex row ignores */}
				<Button
					variant="info"
					className="mr-auto"
					onClick={() =>
						window.open(messages["admin.clientSettings.absenceCalendar.helpCenterArticleUrl"], "_blank")
					}
				>
					<FA6Icon icon="circle-question" variant="regular" fixedWidth className="mr-5"/>
					{messages["dialog.learnMore"]}
				</Button>
				<Modal.Close render={<Button variant="secondary" type="button"/>} disabled={busy}>
					<FA6Icon icon="xmark" variant="regular" fixedWidth className="mr-5"/>
					{messages["dialog.close"]}
				</Modal.Close>
			</Modal.Footer>
		</Modal.Content>
	);
}
